import Localizr from '../utils/Localizr';
import Preloader from '../utils/Preloader';

import './guestbook.scss';

class Guestbook {
  constructor() {
    this.layout();
    this.initButtons();
  }

  layout() {
    document.querySelector('#shell').appendChild(Localizr.template(Preloader.getFile('guestbook-template'), {}));

    Localizr.parseObjectList(settings.sections.guestbook.items);
  }

  initButtons() {
    document.querySelector('#signInBtn').addEventListener('click', () => alert('Sorry, guest book full.'));
  }

  preenter() {}

  enter() {
    // trackPageView('Guestbook');
    return new Promise((resolve, reject) => {
      resolve();
    });
  }

  onEnterStart() {
    resizer.force();
  }

  onEnterComplete() {
    SITE.utils.sequencer.next();
  }

  exit() {
    return new Promise((resolve, reject) => {
      resolve();
    });
  }

  postExit() {}

  onResize(sizes) {}
}

export default Guestbook;
